import { render, staticRenderFns } from "./customerDetail2.vue?vue&type=template&id=91eb4f1c&scoped=true&"
import script from "./customerDetail2.vue?vue&type=script&lang=js&"
export * from "./customerDetail2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91eb4f1c",
  null
  
)

export default component.exports